import {
	TICKET_LIST_GET_LIST,
	TICKET_LIST_GET_LIST_SUCCESS,
	TICKET_LIST_GET_LIST_ERROR,
	TICKET_LIST_GET_LIST_WITH_FILTER,
	TICKET_GET,
	TICKET_GET_SUCCESS,
	TICKET_GET_ERROR
} from '../actions';

const INIT_STATE = {
	alltickets: null,
	tickets: null,
	loading: false,
	currentUser: null,
	ticketdetailloading: false,
	selectedTicket: null,
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case TICKET_LIST_GET_LIST:
			return { ...state, loading: false };

		case TICKET_LIST_GET_LIST_SUCCESS:
			//console.log(action.payload)       ; 
			return { ...state, loading: true, alltickets: action.payload.tickets, tickets: action.payload.tickets, currentUser: action.payload.currentUser };

		case TICKET_LIST_GET_LIST_ERROR:
			return { ...state, loading: true, error: action.payload };

		case TICKET_GET:
			return { ...state, ticketdetailloading: false };

		case TICKET_GET_SUCCESS:
			console.log(action.payload);
			return { ...state, ticketdetailloading: true, selectedTicket: action.payload.ticket };

		case TICKET_GET_ERROR:
			return { ...state, ticketdetailloading: true, error: action.payload };

		default: return { ...state };

		case TICKET_LIST_GET_LIST_WITH_FILTER:
			console.log(action.payload);
			if (action.payload.startDate === '' || action.payload.endDate === '') {
				return { ...state, loading: true, tickets: state.alltickets, filter: null };
			} else {

				const filteredItems = state.alltickets.filter((item) =>
					//console.log(new Date(item["chatDateTime"]).getTime())
					new Date(item["chatDateTime"]).getTime() >= new Date(action.payload.startDate).getTime() &&
					new Date(item["chatDateTime"]).getTime() <= new Date(action.payload.endDate).getTime()
					&& (item["hotel"] === action.payload.hotel || "-1" === action.payload.hotel)
				);
				//item[action.payload.column] === action.payload.value);
				return {
					...state, loading: true, tickets: filteredItems, filter: {
						startDate: action.payload.startDate,
						endDate: action.payload.endDate
					}
				}
			}
	}
}
